import gql from 'graphql-tag';
import { DEAL_SMS_ACTIVITY_FRAGMENT } from './fragments/dealSmsActivity.fragment';

export const CREATE_SMS_ACTIVITY = gql`
  mutation CreateSmsActivity($input: CreateSmsActivityInput!) {
    messaging {
      createSmsActivity(input: $input) {
        error
        success
        entity {
          ...DealSmsActivityFields
          __typename
        }
      }
    }
  }
  ${DEAL_SMS_ACTIVITY_FRAGMENT}
`;
